export enum AccountingUserTypeEnum {
	EMPLOYEE = 'EMPLOYEE',
	INVESTOR = 'INVESTOR',
}
